export { default } from './LoginAttemptsExceededModal'
export type { ILoginAttemptsExceededModalProps } from './types'
